import type { Actor } from "../protocol";
import { word } from "../i18n";

/** user id → display name, from presence and the share's owner. */
export type Names = ReadonlyMap<string, string>;

/** Who did it: the role, and the person's name where there is one. */
export function Badge({ actor, names }: { actor: Actor; names: Names }) {
  // the name the relay or the trajectory carried, else who presence says
  // the id is, else the id
  const name = actor.user ? (actor.name || names.get(actor.user) || actor.user) : undefined;
  return (
    <span className={`badge badge-${actor.kind}`} title={actor.user}>
      <span className="badge-role">{word("common:role", actor.kind) ?? actor.kind}</span>
      {name && <span className="badge-name">{name}</span>}
    </span>
  );
}
